import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Stack,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import InfoRow from './InfoRow';
import { mascaraCpfCnpj } from 'utils/format_cpf';
import { formatDate } from 'utils/format_date';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  data: any;
  onVisualizar: () => void;
  onConfirm: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ open, onClose, loading, data, onVisualizar, onConfirm }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle>
      <Typography variant="h6" textAlign="center">
        Confirmar Envio
      </Typography>
    </DialogTitle>

    <DialogContent dividers>
      {loading && (
        <Box display="flex" alignItems="center" justifyContent="center" minHeight={180}>
          <CircularProgress />
        </Box>
      )}

      {!loading && data && (
        <Stack spacing={2}>
          <Alert severity="warning">
            Ao enviar esta coleta para o Estado, <strong>não será mais possível editar os dados</strong>. Confira as informações abaixo.
          </Alert>

          <Box sx={{ bgcolor: '#f8f9fb', borderRadius: 2, p: 2 }}>
            <InfoRow label="CPF" value={mascaraCpfCnpj(data?.informant_cpf)} />
            <InfoRow label="Nome do Responsável" value={data?.informant_full_name} />
            <InfoRow label="Nome da Unidade Familiar" value={data?.family_unit_name} />
            <InfoRow label="Situação atual" value={data?.status} />
            <InfoRow label="Qtd. Integrantes" value={data?.family_members_count} />
            <InfoRow label="Atualizado em" value={formatDate(data?.updatedAt)} />
          </Box>

          {data?.resumo && (
            <Box>
              <Typography variant="subtitle2" gutterBottom>
                Resumo
              </Typography>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                {data.resumo}
              </Typography>
            </Box>
          )}

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            <Button variant="outlined" startIcon={<VisibilityIcon />} onClick={onVisualizar}>
              Ver ficha completa
            </Button>
          </Stack>
        </Stack>
      )}

      {!loading && !data && (
        <Alert severity="info">Nenhum dado encontrado para a coleta informada.</Alert>
      )}
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose} color="secondary">
        Cancelar
      </Button>
      <Button onClick={onConfirm} color="primary" disabled={loading || !data}>
        Confirmar envio
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmModal;
